import { PromotionBanner } from "@clipboard-health/ui-components";
import { REFER_AND_EARN_WITH_ACCOUNTS_PATH } from "@src/appV2/Accounts/ReferAndEarn/paths";
import { WORKPLACE_REFERRALS_WITH_ACCOUNTS_PATH } from "@src/appV2/Accounts/WorkplaceReferrals";
import { useWorkerToWorkplaceAffiliateExperiment } from "@src/appV2/Accounts/WorkplaceReferrals/hooks/useWorkerToWorkplaceAffiliateExperiment";
import {
  WorkplaceReferralAction,
  WorkplaceReferralComponent,
} from "@src/appV2/Accounts/WorkplaceReferrals/types";
import { getWorkerToWorkplaceVariantName } from "@src/appV2/Accounts/WorkplaceReferrals/utils/getWorkerToWorkplaceVariantName";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { useHistory } from "react-router-dom";

export function WorkplaceReferralsBanner() {
  const isWorkerToWorkplaceAffiliateProgramEnabled = useWorkerToWorkplaceAffiliateExperiment();
  const history = useHistory();

  const title = "Get paid for referring workplaces!";

  const pathname = isWorkerToWorkplaceAffiliateProgramEnabled
    ? WORKPLACE_REFERRALS_WITH_ACCOUNTS_PATH
    : REFER_AND_EARN_WITH_ACCOUNTS_PATH;

  const handleClick = () => {
    logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL, {
      action: WorkplaceReferralAction.BANNER_CLICKED,
      component: WorkplaceReferralComponent.WORKPLACE_REFERRAL_BANNER,
      variant: getWorkerToWorkplaceVariantName(isWorkerToWorkplaceAffiliateProgramEnabled),
    });

    history.push(`${pathname}?source=workplaceReferralBanner`);
  };

  return (
    <PromotionBanner
      title={title}
      subtitle="Earn up to $1,000 for every workplace you refer to Clipboard, once their first shift is verified"
      icon="dollar-with-circle"
      backgroundColor={(theme) => theme.palette.common.white}
      borderColor={(theme) => theme.palette.onboarding!.inProgress.gradient}
      borderVariant="gradient"
      onClick={handleClick}
    />
  );
}
